import { FC } from "react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/cn";

interface FileScanStatusBadgeProps {
  scanStatus: string;
}

export const FileScanStatusBadge: FC<FileScanStatusBadgeProps> = ({ scanStatus }) => {
  const { t } = useTranslation("common");

  if (scanStatus === "CLEAN") {
    return null;
  }

  const config: Record<string, { label: string; className: string }> = {
    PENDING: {
      label: t("fileScanStatus.pending", "Scanning..."),
      className: "bg-yellow-100 text-yellow-800",
    },
    SCANNING: {
      label: t("fileScanStatus.scanning", "Scanning..."),
      className: "bg-yellow-100 text-yellow-800",
    },
    INFECTED: {
      label: t("fileScanStatus.infected", "Threat detected"),
      className: "bg-red-100 text-red-800",
    },
    ERROR: {
      label: t("fileScanStatus.error", "Scan error"),
      className: "bg-muted text-slate-800",
    },
  };

  const statusConfig = config[scanStatus];
  if (!statusConfig) {
    return null;
  }

  return (
    <span className={cn("inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium", statusConfig.className)}>
      {statusConfig.label}
    </span>
  );
};
